import _ from 'lodash'
import { formatNumber } from 'core/service/lib/number-format'
import { connect } from 'react-redux'
import { getInvestmentBenefit } from './selectors'
import { getLegalDisclaimerEndDate } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getcoveragePlanStartDate } from 'quick-quote/product-common/coverage-plan/selectors'
import { getSelectedDisplayProductNameThai } from 'quick-quote/product-selection/selectors'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { WordWraps } from 'common-components'

export const _InvestmentBenefitTable = ({
  investmentBenefit,
  productName,
  legalDisclaimerEndDate,
  coveragePlanStartDate,
}) => {
  return (
    <div className="group" id="investment-benefit-2">
      <h3>{MESSAGES.INVESTMENT_BENEFITS}</h3>
      <div className="dividend-table">
        <table>
          <thead>
            <tr>
              <td width="40%">{MESSAGES.INVESTMENT_BENEFITS_SUMMARY}</td>
              <td>{MESSAGES.INVESTMENT_BENEFITS_GUARANTEE}</td>
            </tr>
          </thead>
          <tbody>
            {investmentBenefit.benefitSummaryUniversalLink?.map((v, k) => (
              <InvestmentBenifitComponent datas={v} key={`benefit_summary_universal_link${k}`} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const InvestmentBenifitComponent = ({ datas }) => {
  if (
    datas.title === 'สิ้นปีกรมธรรม์ที่ 2 และ 4 ปีละ' ||
    datas.title === 'สิ้นปีกรมธรรม์ที่ 6, 8, 10, 12 และ 14 ปีละ'
  ) {
    return (
      <tr>
        <td>
          <text style={{ marginLeft: '16px' }}>{datas.title}</text>
        </td>
        <Amount amount={datas.value} />
      </tr>
    )
  } else if (datas.title === '4) เงินปันผล') {
    return (
      <tr>
        <td>
          <text style={{ fontWeight: 'bold' }}>{datas.title}</text>
        </td>
        <td style={{ fontSize: '18px', textAlign: 'left' }}>
          <WordWraps>{datas.value}</WordWraps>
        </td>
      </tr>
    )
  } else {
    return (
      <tr>
        <td>
          <text style={{ fontWeight: 'bold' }}>{datas.title}</text>
        </td>
        {datas.value ? <Amount amount={datas.value} /> : <td></td>}
      </tr>
    )
  }
}

const Amount = ({ amount }) => <td>{formatNumber(amount, 0, true)} บาท</td>

const mapStateToProps = (state) => ({
  investmentBenefit: getInvestmentBenefit(state),
  legalDisclaimerEndDate: getLegalDisclaimerEndDate(state),
  coveragePlanStartDate: getcoveragePlanStartDate(state),
  productName: getSelectedDisplayProductNameThai(state),
})
export default connect(mapStateToProps)(_InvestmentBenefitTable)
